import { makeVar } from '@apollo/client';

export const signupStepVar = makeVar<
  'signup' | 'confirmEmail' | 'chooseUsername' | 'setupMFA'
>('signup');
